module.exports = "<div class=\"loader\">Loading...</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/loading/loading.component.html
// module id = ./src/app/loading/loading.component.html
// module chunks = main